/*
 * @Author: yeweimao yeweimao@zhuanzhuan.com
 * @Date: 2022-04-24 14:27:06
 * @LastEditors: yeweimao yeweimao@zhuanzhuan.com
 * @LastEditTime: 2022-08-26 11:40:49
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import native from '@zz-common/native-adapter'

const asyncAdapter = (method, params, callback) => {
  if (Object.keys(params).length == 0) {
    return native.wrap(method)(callback)
  }
  return native.wrap(method)(params, callback && callback)
}

//获取机型顶部状态栏高度
export const getStatusBarHeight = (params, callback) => {
  asyncAdapter('getStatusBarHeight', params, callback)
}
//设置顶部状态栏模式
export const setStatusBarDarkMode = (params, callback) => {
  asyncAdapter('setStatusBarDarkMode', params, callback)
}
//判断是否登录
export const isLogin = () => {
  return native.isLogin()
}
//跳转
export const skipToUrl = (params, callback) => {
  asyncAdapter('skipToUrl', params, callback)
}

//登录
export const nativeLogin = (params) => {
  const insetCallback = params.callback
  params.callback = function (res) {
    if (!res) {
      return
    }
    insetCallback && insetCallback(res)
  }
  asyncAdapter('login', params)
}

//监听页面返回
export const RegisterPageCallback = (params) => {
  const insetCallback = params.callback
  params.callback = function (res) {
    if (!res) {
      return
    }
    insetCallback && insetCallback(res)
  }
  asyncAdapter('registerPageCallback', params)
}
//关闭当前页
export const pageClose = () => {
  return native.close()
}

//分享
export const pageShare = (params) => {
  asyncAdapter('shareClick', params)
}

// 小程序分享
export const waShare = (params) => {
  asyncAdapter('share', params)
}
//获取消息数量
export const getMsgCount = (params, callback) => {
  asyncAdapter('getAllUnreadCount', params, callback)
}
//判断所属平台
export const isPlatform = (Platform) => {
  return native.in(Platform) || false
}

//跳转到详情
export const skipToDetail = (params) => {
  asyncAdapter('skipToDetail', params)
}

//客户端跳转
export const enterUnifiedUrl = (params) => {
  asyncAdapter('enterUnifiedUrl', params)
}

export const playVideoBySystem = (params) => {
  asyncAdapter('playVideoBySystem', params)
}

export const enlargeImage = (params) => {
  asyncAdapter('enlargeImage', params)
}

//判断当前端内是否支持某个方法
export const hasSupportFeature = (params, callback) => {
  asyncAdapter('hasSupportFeature', params, callback)
}

//图片放大
export const browserLuxuryImages = (params, callback) => {
  asyncAdapter('browserLuxuryImages', params, callback)
}

//根据页面标识关闭页面
export const closeByMark = (params, callback) => {
  asyncAdapter('closeByMark', params, callback)
}

//图片放大
export const setKeyboardFrameChangeCallback = (callback) => {
  asyncAdapter('browserLuxuryImages', callback)
}

export const nativeToast = (params, callback) => {
  asyncAdapter('toast', params, callback)
}
